import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b129cf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "family-list-item" }

import { ViewPerson } from '@/rd/ResearchDataModel'
import PersonListItem from './PersonListItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyListItem',
  props: {
    familyId: {},
    father: {},
    mother: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PersonListItem, { person: _ctx.father }, null, 8, ["person"]),
    _createVNode(PersonListItem, { person: _ctx.mother }, null, 8, ["person"])
  ]))
}
}

})